import UAParserJS from 'ua-parser-js';

const uaParserJS = new UAParserJS();

export const getBrowserName = () => {
    const browser = uaParserJS.setUA(navigator.userAgent).getBrowser();

    return `${browser.name} ${browser.version}`;
};
